import CatalogNavigationClass from './components/common/CatalogNavigationClass';
import CatalogSearchClass from './components/common/CatalogSearchClass';
import loadVideo from './components/website/loadVideo';
import { isElementIntoView } from './helpers/common-helpers';

window.addEventListener('DOMContentLoaded', () => {
    const catalogNavigation = new CatalogNavigationClass();
    new CatalogSearchClass(catalogNavigation);
    loadVideo();

    isElementIntoView('.js-animated', async _ => {
        const clientLists = [...document.querySelectorAll('.js-animated')];

        if (clientLists.length) {
            clientLists.forEach((client) => {
                client.classList.add('is-animated');
            })
        }
    });

    // Dynamic imports for performance optimization
    isElementIntoView('.js-lottie-animation', async _ => {
        const { default: lottieAnimation } = await import(/* webpackChunkName: "lottie" */ './components/website/lottieAnimation');
        lottieAnimation();
    });
});
